import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '../context/ThemeContext';
const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();
    return (_jsx("button", { className: "btn-touch btn-touch-secondary", onClick: toggleTheme, "aria-label": `Switch to ${theme === 'light' ? 'dark' : 'light'} theme`, title: `Switch to ${theme === 'light' ? 'dark' : 'light'} theme`, children: _jsx("i", { className: `fas ${theme === 'light' ? 'fa-moon' : 'fa-sun'}` }) }));
};
export default ThemeToggle;
